// @flow

import React from 'react';
import PropTypes from 'prop-types';

//Components
import ErrorSuccessModal from './ErrorSuccessModal';

// Helpers
import { mutations } from '../utils/constants';
import type { MutationResponses } from '../utils/constants';
import {
    SuccessTitle,
    SuccessDescription,
    ErrorTitle,
    ErrorDescription,
} from '../messages/errorSuccessMessages';

type ErrorSuccessContainerProps = {
    mutationResponse: MutationResponses,
    type: string,
    closeModal: () => void,
    modalOpen: boolean,
};

const ErrorSuccessContainer = ({
    mutationResponse,
    type,
    closeModal,
    modalOpen,
}: ErrorSuccessContainerProps) => {
    const isSuccess = mutationResponse === mutations.responses.SUCCESS;
    if (mutationResponse === mutations.responses.LOADING) {
        return null;
    }

    const title = isSuccess ? <SuccessTitle type={type} /> : <ErrorTitle type={type} />;
    const description = isSuccess ? (
        <SuccessDescription type={type} closeModal={closeModal} />
    ) : (
        <ErrorDescription type={type} />
    );

    return (
        <ErrorSuccessModal
            description={description}
            onClose={closeModal}
            isOpen={modalOpen}
            title={title}
            type={mutationResponse}
        />
    );
};

ErrorSuccessContainer.propTypes = {
    mutationResponse: PropTypes.string,
    type: PropTypes.string,
    modalOpen: PropTypes.bool,
    closeModal: PropTypes.func,
};

export default ErrorSuccessContainer;
